module.exports = __webpack_public_path__ + "static/media/trading_post.0c7daadb.png";